import { IFullPlanDetail } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";
import { getDoubleDeepHMO } from "../../../functions/planDetails";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const DataTableDetailMentalHealth = ({ data }: { data: IFullPlanDetail }) => {
  const { selectedYear } = useZipRootLoaderData();
  const inpatientHospitalBenefit = getDoubleDeepHMO(
    data,
    "Inpatient Hospital",
    "Inpatient Hospital Psychiatric"
  );
  const mentalHealthBenefits = getDoubleDeepHMO(
    data,
    "Mental Health Services",
    selectedYear === 2024
      ? "Mental Health Specialty Services (Individual and Group)"
      : "Mental Health Specialty Services"
  );
  const psyhiatricServiceBenefits = getDoubleDeepHMO(
    data,
    "Mental Health Services",
    "Psychiatric Services (Individual and Group)"
  );

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <SingleInfoBenefit
        benefit={inpatientHospitalBenefit}
        title="Inpatient Hospital - Psychiatric"
      />
      <SingleInfoBenefit
        benefit={mentalHealthBenefits}
        title="Mental Health Speciality"
      />
      <SingleInfoBenefit
        benefit={psyhiatricServiceBenefits}
        title="Psychiatric Services"
      />
    </div>
  );
};

export default DataTableDetailMentalHealth;
